<page-grid [gridConfig]="adxInvoiceErpAdjustmentsGrid" (gridEvent)="openAddAdjustmentDialog()"></page-grid>
